import { env } from '@skin-seoul/env-utils';

import type {
  HubSpotContactFormData,
  HubSpotFormSubmissionRequest,
  HubSpotFormSubmissionResponse,
} from './utils/types';

class HubSpotAPIClient {
  private readonly baseUrl = 'https://api.hsforms.com/submissions/v3/integration/submit';

  private getHubSpotCookie(): string | undefined {
    if (typeof document === 'undefined') return undefined;
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith('hubspotutk='))
      ?.split('=')[1];
  }

  private buildFormContext(): HubSpotFormSubmissionRequest['context'] {
    return {
      hutk: this.getHubSpotCookie(),
      pageUri: typeof window !== 'undefined' ? window.location.href : '',
      pageName: typeof document !== 'undefined' ? document.title : '',
    };
  }

  public async submitContactForm(data: HubSpotContactFormData): Promise<HubSpotFormSubmissionResponse> {
    const portalId = env('NEXT_PUBLIC_HUBSPOT_PORTAL_ID');
    const formGuid = env('NEXT_PUBLIC_HUBSPOT_CHECKOUT_FORM_GUID');
    const url = `${this.baseUrl}/${portalId}/${formGuid}`;

    const payload: HubSpotFormSubmissionRequest = {
      fields: [
        { name: 'name', value: data.name },
        { name: 'email', value: data.email },
        { name: 'phone', value: data.phone },
      ],
      context: this.buildFormContext(),
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('[HubSpot] Form submission failed:', errorData);
      throw new Error(`HubSpot form submission failed: ${response.status}`);
    }

    return response.json();
  }
}

export const hubspotAPIClient = new HubSpotAPIClient();
